export const SCHEMAS = {
  universe: {
    title: "Univers",
    fields: [
      { key: "number", label: "Numéro", type: "text" },
      { key: "title", label: "Titre", type: "text" },
      { key: "description", label: "Description", type: "textarea" },
      { key: "image", label: "Image", type: "file", kind: "image" },
    ],
    listPrimary: "title", listSecondary: "number",
  },
  experiences: {
    title: "Expériences",
    fields: [
      { key: "caption", label: "Légende", type: "text" },
      { key: "description", label: "Description", type: "textarea" },
      { key: "media_type", label: "Type de média", type: "select", options: [{ value: "image", label: "Image" }, { value: "video", label: "Vidéo" }] },
      { key: "media_url", label: "Média", type: "file", kind: "image" },
    ],
    listPrimary: "caption", listSecondary: "media_type",
  },
  events: {
    title: "Événements",
    fields: [
      { key: "title", label: "Titre", type: "text" },
      { key: "description", label: "Description", type: "textarea" },
      { key: "date", label: "Date", type: "text" },
      { key: "time", label: "Heure", type: "text" },
      { key: "starts_at", label: "Date/heure de début (pour rappel auto 24h avant)", type: "datetime" },
      { key: "location", label: "Lieu", type: "text" },
      { key: "category", label: "Catégorie", type: "text" },
      { key: "timeframe", label: "Période", type: "select", options: [{ value: "upcoming", label: "À venir" }, { value: "past", label: "Passé" }] },
      { key: "external_link", label: "Lien externe", type: "text" },
      { key: "ticketing_enabled", label: "Billetterie active", type: "select", options: [{ value: "true", label: "Oui" }, { value: "false", label: "Non" }] },
      { key: "ticket_price", label: "Prix du billet (CAD)", type: "number" },
      { key: "ticket_quota", label: "Quota de billets (0 = illimité)", type: "number" },
      { key: "image", label: "Image", type: "file", kind: "image" },
      { key: "video", label: "Vidéo (option)", type: "file", kind: "video" },
    ],
    listPrimary: "title", listSecondary: "date",
  },
  artists: {
    title: "Artistes",
    fields: [
      { key: "name", label: "Nom", type: "text" },
      { key: "discipline", label: "Discipline", type: "text" },
      { key: "description", label: "Description", type: "textarea" },
      { key: "photo", label: "Photo / logo", type: "file", kind: "image" },
      { key: "instagram", label: "Instagram", type: "text" },
      { key: "website", label: "Site web", type: "text" },
      { key: "projects", label: "Projets associés", type: "textarea" },
    ],
    listPrimary: "name", listSecondary: "discipline",
  },
  collaborators: {
    title: "Collaborateurs",
    fields: [
      { key: "name", label: "Nom", type: "text" },
      { key: "discipline", label: "Discipline", type: "text" },
      { key: "description", label: "Description", type: "textarea" },
      { key: "photo", label: "Photo / logo", type: "file", kind: "image" },
      { key: "instagram", label: "Instagram", type: "text" },
      { key: "website", label: "Site web", type: "text" },
      { key: "projects", label: "Projets associés", type: "textarea" },
    ],
    listPrimary: "name", listSecondary: "discipline",
  },
  audio_tracks: {
    title: "EFFERVESCENCE Sound",
    fields: [
      { key: "title", label: "Titre", type: "text" },
      { key: "artist", label: "Artiste", type: "text" },
      { key: "source_type", label: "Source", type: "select", options: [{ value: "owned", label: "OWNED AUDIO (upload)" }, { value: "embed", label: "EXTERNAL EMBED (iframe)" }] },
      { key: "audio_url", label: "Fichier audio (owned)", type: "file", kind: "audio" },
      { key: "embed_platform", label: "Plateforme (embed)", type: "text" },
      { key: "embed_url", label: "URL embed iframe (embed)", type: "text" },
      { key: "cover", label: "Pochette", type: "file", kind: "cover" },
    ],
    listPrimary: "title", listSecondary: "artist",
  },
  playlists: {
    title: "Playlists",
    fields: [
      { key: "title", label: "Titre", type: "text" },
      { key: "description", label: "Description", type: "textarea" },
      { key: "cover", label: "Pochette", type: "file", kind: "cover" },
      { key: "track_ids", label: "Pistes de la playlist", type: "tracks" },
    ],
    listPrimary: "title", listSecondary: "description",
  },
  subscription_plans: {
    title: "Abonnements",
    fields: [
      { key: "name", label: "Nom du niveau", type: "text" },
      { key: "price_monthly", label: "Prix mensuel (CAD)", type: "number" },
      { key: "benefits", label: "Avantages (un par ligne)", type: "textarea" },
    ],
    listPrimary: "name", listSecondary: "price_monthly",
  },
};
